import { motion } from "framer-motion";
import RelatedContentCarousel from "@/components/RelatedContentCarousel";

export const EVENTS_DEFAULT_DATA = {
  title_prefix: "",
  title_accent: "Events",
  title_trail: "& Conferences",
  tagline: "Meet the Antera team at industry events, conferences, and webinars throughout the year.",
  related: {
    tag: "Events",
    title: "Latest from Antera Events",
    subtitle: "Event coverage, expo recaps, and conference highlights from the Antera team.",
  },
};

export default function EventsPage({ data }) {
  const src = data || {};
  const d = { ...EVENTS_DEFAULT_DATA, ...src };
  const related = { ...EVENTS_DEFAULT_DATA.related, ...(src.related || {}) };

  return (
    <div data-testid="events-page" className="page-transition">
      <section className="pt-32 pb-10 lg:pt-40 lg:pb-12 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}>
            <h1 className="text-4xl sm:text-5xl font-extrabold tracking-tight text-slate-900">
              {d.title_prefix ? <>{d.title_prefix} </> : null}
              <span className="text-sky-600">{d.title_accent}</span>
              {d.title_trail ? <> {d.title_trail}</> : null}
            </h1>
            <p className="mt-5 text-base lg:text-lg text-slate-500 leading-relaxed max-w-2xl mx-auto">
              {d.tagline}
            </p>
          </motion.div>
        </div>
      </section>

      <RelatedContentCarousel
        tag={related.tag}
        title={related.title}
        subtitle={related.subtitle}
        testId="events-related"
      />
    </div>
  );
}
